import { createSlice } from '@reduxjs/toolkit'
import { fetchDocumentById, fetchDocumentsByFolder } from './documentAction'
import { DocumentState } from '../../types/documentTypes'

const initialState: DocumentState = {
  document: null,
  documents: null,
  loading: false,
  error: null,
}

const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDocumentById.fulfilled, (state, action) => {
        state.loading = false
        state.document = action.payload
      })
      .addCase(fetchDocumentById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
      .addCase(fetchDocumentsByFolder.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDocumentsByFolder.fulfilled, (state, action) => {
        state.loading = false
        state.documents = action.payload
      })
      .addCase(fetchDocumentsByFolder.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
  },
})

export default documentSlice.reducer
